import { FaEdit, FaEye, FaEyeSlash, FaFileUpload, FaTimes } from "react-icons/fa";
import Switch from "../../components/Switch/Switch";
import { FaSave } from "react-icons/fa"; // Save icon
import { viewFileFromS3 } from "../../services/s3Service";

export const tableConstants = (
  uploadHandler,
  uploadSingleFileHandler,
  selectedFiles,
  currentPage,
  isAllSelected,
  selectedTeacherIds,
  handleSelectAll,
  handleTeacherSelect,
  singleStatusToggleHandler,
  savingTeacherId,
  togglingTeacherId,
  clearSelectedFileHandler,
) => {
  let formatedData = [
    {
      title: "S.No",
      render: (_, idx) => {
        const safeCurrentPage = Number(currentPage) || 1;
        return <span>{(safeCurrentPage - 1) * 100 + (idx + 1)}</span>;
      },
    },
    {
      title: "name",
      render: (rowData) => {
        return <span>{rowData.name}</span>;
      },
    },
    {
      title: "email",
      render: (rowData) => {
        return <span>{rowData.email}</span>;
      },
    },
    {
      title: "role",
      render: (rowData) => {
        return <span>{rowData.role ? rowData.role : ""}</span>;
      },
    },
    {
      title: "Upload",
      render: (rowData) => {
        const isFileSelected = selectedFiles[rowData.id];
        const isSaving = savingTeacherId === rowData.id;
        return (
          <div className="tt-upload-container">
            <input
              type="file"
              name={`timetable_${rowData.id}`}
              id={`timetable_${rowData.id}`}
              className="tt-file-input-hidden"
              onChange={(e) => uploadHandler(e, rowData.id)}
              disabled={isSaving}
            />
            <label
              htmlFor={`timetable_${rowData.id}`}
              className={`tt-upload-label ${isSaving ? "tt-upload-label-disabled" : ""}`}
            >
              <FaFileUpload /> {isFileSelected ? "Change" : "Upload"}
            </label>
            {isFileSelected && (
              <span className="tt-file-selected" title={isFileSelected.name}>
                ✅ {isFileSelected.name}
                <button
                  type="button"
                  className="tt-file-clear-btn"
                  title="Remove selected file"
                  disabled={isSaving}
                  onClick={() => clearSelectedFileHandler(rowData.id)}
                >
                  <FaTimes />
                </button>
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: "Action",
      render: (rowData) => {
        const isUploaded = Number(rowData.timetable_status) === 1;
        const isFileSelected = !!selectedFiles[rowData.id];
        const isSaving = savingTeacherId === rowData.id;
        const actionLabel = isUploaded ? "Update" : "Save";
        return (
          <button
            type="button"
            className={`tt-action-btn ${isUploaded ? "tt-action-btn-edit" : "tt-action-btn-save"}`}
            title={
              isFileSelected
                ? actionLabel
                : "Choose a file first to enable this action"
            }
            disabled={!isFileSelected || isSaving}
            onClick={(e) => uploadSingleFileHandler(e, rowData.id)}
          >
            {isSaving ? (
              <span className="tt-spinner" />
            ) : isUploaded ? (
              <FaEdit />
            ) : (
              <FaSave />
            )}
            {isSaving ? "Saving..." : actionLabel}
          </button>
        );
      },
    },
    {
      title: "View",
      render: (rowData) => {
        return (
          <span>
            <span
              title="View Timetable"
              className="tt-view-icon-wrap"
              onClick={async () => {
                if (!rowData.timetable_path) return;
                try {
                  const res = await viewFileFromS3(rowData.timetable_path);
                  if (res.data && res.data.data && res.data.data.file_url) {
                    window.open(res.data.data.file_url, "_blank");
                  } else {
                    alert("Unable to fetch the timetable. Please try again later.");
                  }
                } catch {
                  alert("Unable to fetch the timetable. Please try again later.");
                }
              }}
            >
              {!rowData.timetable_path ? (
                <FaEyeSlash className="tt-view-icon" />
              ) : (
                <FaEye className="tt-view-icon" />
              )}
            </span>
          </span>
        );
      },
    },
    {
      title: () => (
        <Switch
          checked={isAllSelected}
          id="select-all-teachers"
          value="all"
          onChange={handleSelectAll}
          label="All"
        />
      ),
      render: (rowData) => {
        const currentStatus = selectedTeacherIds.includes(rowData.id.toString())
          ? 1
          : 0;
        const isToggling = togglingTeacherId === rowData.id;
        return (
          <span className={`tt-switch-cell ${isToggling ? "tt-switch-cell-busy" : ""}`}>
            {isToggling && <span className="tt-spinner tt-spinner-inline" />}
            <Switch
              checked={currentStatus === 1}
              id={`select-teacher-${rowData.id}`}
              value={rowData.id.toString()}
              disabled={isToggling}
              onChange={() =>
                singleStatusToggleHandler(rowData.id, currentStatus)
              }
            />
          </span>
        );
      },
    },
  ];
  return formatedData;
};
